export default __webpack_public_path__ + "static/media/credit-karma.bf81ff0a.png";